(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sale-card"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(e){
  var b = e.target.closest('.scard .add[data-vid]');
  if(!b) return;
  e.preventDefault();
  b.classList.add('busy');
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method:'POST', headers:{'Content-Type':'application/json'},
    body: JSON.stringify({ items:[{ id: parseInt(b.dataset.vid,10), quantity:1 }] })
  }).then(function(r){ return r.json(); }).then(function(){
    document.dispatchEvent(new CustomEvent('cart:refresh',{ detail:{ open:true }}));
  }).catch(function(){ window.location.href = b.closest('.scard').querySelector('.view').href; })
    .finally(function(){ b.classList.remove('busy'); });
});
  } catch(e) { console.error(e); }
})();

})();
